<div>
	<p>
		<ng-container i18n="Imported items details@@adminDataImportResponseShowcaseImportedItemsMessage">Total items to import: </ng-container><b>{{ dialogSettings?.total }}</b>
	</p>
	<p>
		<ng-container i18n="Imported items details@@adminDataImportResponseShowcaseSuccessfullyImportedMessage">Successfully imported: </ng-container><b>{{ dialogSettings?.success }}</b>
	</p>
	<p>
		<ng-container i18n="Imported items details@@adminDataImportResponseShowcaseFailedImportsMessage">Failed imports: </ng-container><b>{{ dialogSettings?.fail }}</b></p>

	<div *ngIf="dialogSettings.failedItems.length">
		<div i18n="Failed items title@@adminDataImportResponseShowcasefailedItemsTitle">
			Failed items:
		</div>
		<p *ngFor="let failedItem of dialogSettings.failedItems">
			{{ failedItem }}
		</p>
	</div>

	<p i18n="Imported items details@@adminDataImportResponseShowcaseDownloadReportMessage">Download report for more information.</p>
</div>

<div mat-dialog-actions class="dialog-footer">
	<div>
		<button
			mat-button
			mat-dialog-close="null"
			color="primary"
			class="submit pull-right"
		>
			<ng-container *ngIf="dialogSettings.cancelButtonText">{{dialogSettings.cancelButtonText}}</ng-container>
			<ng-container *ngIf="!dialogSettings.cancelButtonText" i18n="Dialog Action Button@@adminDataImportResponseShowcaseCloseButton">Close</ng-container>
		</button>
	</div>
</div>
